import { Injectable } from '@angular/core';
import { QualificationTrainings } from '@wilson/interfaces';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TrainingQualificationsV2ListService {
  private _bulkDeleteQualificationTrainings = new Subject<void>();
  public bulkDeleteQualificationTrainings$ =
    this._bulkDeleteQualificationTrainings.asObservable();

  private selectedQualificationTrainingsSubject = new BehaviorSubject<
    QualificationTrainings[]
  >([]);
  public selectedQualificationTrainings$ =
    this.selectedQualificationTrainingsSubject.asObservable();

  public selectedQualificationTrainingsCount$ =
    this.selectedQualificationTrainings$.pipe(
      startWith([]),
      map((qualifications) => ({ count: qualifications.length })),
    );

  private _bulkImportedQualificationTrainings = new Subject<void>();
  public bulkImportedQualificationTrainings$ =
    this._bulkImportedQualificationTrainings.asObservable();

  setSelectedQualificationTrainings(
    qualifications: QualificationTrainings[],
  ): void {
    this.selectedQualificationTrainingsSubject.next(qualifications);
  }

  getSelectedQualifications(): QualificationTrainings[] {
    return this.selectedQualificationTrainingsSubject.getValue();
  }

  clearSelection(): void {
    this.selectedQualificationTrainingsSubject.next([]);
  }

  triggerBulkDeleteQualificationTrainings(): void {
    this._bulkDeleteQualificationTrainings.next();
    this.clearSelection();
  }

  triggerBulkImportedQualificationTrainings(): void {
    this._bulkImportedQualificationTrainings.next();
  }
}
